import { webKnots } from 'src/features/atoms/glove/drawer/common/back/lace/webKnots'
import { middleSidePartOfWeb, middleSidePartOfWeb2, topSidePartOfWeb, topSidePartOfWeb3 } from './parts/sideParts'
import { verticalPartOfWeb } from './parts/verticalParts'

export const w31Web = async (
  ctx: CanvasRenderingContext2D,
  laceColor: string,
  stitchColor: string,
  webColor: string,
  webColor2?: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // 横上パーツ
  await topSidePartOfWeb3(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
  // 横下パーツ
  await middleSidePartOfWeb2(ctx, webColor, laceColor, stitchColor, -10, 10, 1, 1, printLeatherTypeValue)
  // 縦パーツ
  await verticalPartOfWeb(ctx, webColor2 || webColor, laceColor, stitchColor, printLeatherTypeValue)
  // laceここから
  webKnots(ctx, laceColor, -120, 120) // 捕球面上のウェブ結び目
}
